import React from 'react';

import { ParametersView } from './view';

export const Parameters = () => (<ParametersView />);